export default "__VITE_PUBLIC_ASSET__4947940d__"